module.exports = __webpack_public_path__ + "static/media/ic_p4off.0737c917.png";